var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 12.1875C11.25 11.1521 10.4104 10.3125 9.375 10.3125H8.4375C6.36621 10.3125 4.6875 11.9912 4.6875 14.0625V16.875C4.6875 18.9463 6.36621 20.625 8.4375 20.625H9.375C10.4104 20.625 11.25 19.7854 11.25 18.75V12.1875ZM21.5625 20.625C23.6338 20.625 25.3125 18.9463 25.3125 16.875V14.0625C25.3125 11.9912 23.6338 10.3125 21.5625 10.3125H20.625C19.5896 10.3125 18.75 11.1521 18.75 12.1875V18.75C18.75 19.7854 19.5896 20.625 20.625 20.625H21.5625ZM15 0C6.63164 0 0.268359 6.9627 0 15V15.9375C0 16.4555 0.419531 16.875 0.9375 16.875H1.875C2.39297 16.875 2.8125 16.4555 2.8125 15.9375V15C2.8125 8.27988 8.27988 2.8125 15 2.8125C21.7201 2.8125 27.1875 8.27988 27.1875 15H27.1805C27.1852 15.1424 27.1875 24.7102 27.1875 24.7102C27.1875 26.0783 26.0783 27.1875 24.7102 27.1875H18.75C18.75 25.6342 17.4908 24.375 15.9375 24.375H14.0625C12.5092 24.375 11.25 25.6342 11.25 27.1875C11.25 28.7408 12.5092 30 14.0625 30H24.7102C27.6316 30 30 27.6316 30 24.7102V15C29.7316 6.9627 23.3684 0 15 0Z",
    fill: "#2948A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.8aaa55afab7ffe7b675cb0f61c420731.svg";
export { ForwardRef as ReactComponent };